import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetAllTransferFromEvaluator = createAsyncThunk(
  "DropDowns/GetAllTransferFromEvaluator",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDownsManager/TransferFromEvaluator",
        param
      );
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "zaza");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetAllTransferToEvaluator = createAsyncThunk(
  "DropDowns/GetAllTransferToEvaluator",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDownsManager/TransferToEvaluator",
        param
      );
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "zaza");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DropDownEvaluator = createSlice({
  name: "DropDownEvaluator",
  initialState: {
    DropDownFromEvaluator: [],
    loadingDropDownFromEvaluator: false,
    errorDropDownFromEvaluator: null,
    /////////////////////////////////
    DropDownToEvaluator: [],
    loadingDropDownToEvaluator: false,
    errorDropDownToEvaluator: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllTransferFromEvaluator.pending, (state, action) => {
        state.loadingDropDownFromEvaluator = true;
        state.DropDownFromEvaluator = action.payload;
        state.errorDropDownFromEvaluator = null;
      })
      .addCase(GetAllTransferFromEvaluator.fulfilled, (state, action) => {
        state.loadingDropDownFromEvaluator = false;
        state.DropDownFromEvaluator = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllTransferFromEvaluator.rejected, (state, action) => {
        state.loadingDropDownFromEvaluator = false;
        state.errorDropDownFromEvaluator = action.payload;
      })
      //////////////////////////////////////////////////////////////////
      .addCase(GetAllTransferToEvaluator.pending, (state, action) => {
        state.loadingDropDownToEvaluator = true;
        state.DropDownToEvaluator = action.payload;
        state.errorDropDownToEvaluator = null;
      })
      .addCase(GetAllTransferToEvaluator.fulfilled, (state, action) => {
        state.loadingDropDownToEvaluator = false;
        state.DropDownToEvaluator = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllTransferToEvaluator.rejected, (state, action) => {
        state.loadingDropDownToEvaluator = false;
        state.errorDropDownToEvaluator = action.payload;
      });
  },
});

export default DropDownEvaluator.reducer;
